import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import { botMessageReceived, selectBotMessageCount } from 'reducers/workflows';

export default function useAnnounceMessageReceived() {
  const dispatch = useAppDispatch();
  const botMessageCount = useAppSelector(selectBotMessageCount);

  useEffect(() => {
    // `> 1` because we don't want to trigger it for the greeting message:
    if (botMessageCount > 1) {
      dispatch(botMessageReceived());
    }
  }, [botMessageCount, dispatch]);
}
